module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "docer-wrapper"
  }, [_c('user-frame', {
    ref: "userframe",
    attrs: {
      "isLogin": _vm.isLogin,
      "discount": _vm.discount
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "docer-content"
  }, [_c('navbar', {
    ref: "navbar",
    attrs: {
      "nav": _vm.nav,
      "tabs": _vm.tabs,
      "isLogin": _vm.isLogin
    },
    on: {
      "navbar_link": _vm.pageRouter,
      "navbar_refresh": _vm.pageRefresh
    }
  }, [_c('in-search', {
    ref: "insearch",
    on: {
      "insearch": _vm.tmplSearch
    }
  })], 1), _vm._v(" "), _c('div', {
    style: ({
      height: _vm.innerHeight,
      minHeight: '500px'
    }),
    attrs: {
      "id": "frame_wrapper"
    }
  }, [(_vm.asyncLoad.Templates && !_vm.maintenance) ? _c('templates', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.nav === 'Templates'),
      expression: "nav === 'Templates'"
    }],
    ref: "templates"
  }) : _vm._e(), _vm._v(" "), (_vm.maintenance) ? _c('maintenance', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.nav === 'Templates'),
      expression: "nav === 'Templates'"
    }]
  }) : _vm._e(), _vm._v(" "), _c('vip-introduce', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.nav === 'WPS Premium'),
      expression: "nav === 'WPS Premium'"
    }],
    attrs: {
      "isLogin": _vm.isLogin,
      "discount": _vm.discount
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-56bb42b2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/v2/main/App.vue
// module id = 100
// module chunks = 1